import { render } from "./RfqsShow.vue?vue&type=template&id=7daf76b1"
import script from "./RfqsShow.vue?vue&type=script&lang=js"
export * from "./RfqsShow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__